module.exports = __webpack_public_path__ + "img/zolasuite.1a9ef03f.jpg";